import React from "react";
import { LOGO } from "../utils/Constants";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer className="footer py-120">
        <div className="container container-lg">
          <div className="footer-item-wrapper d-flex align-items-start flex-wrap justify-content-between">
            <div className="footer-item">
              <div className="footer-item__logo">
                <Link to="#">
                  <img src={LOGO} alt="" />
                </Link>
              </div>
              <p className="mb-24">
                We're online B2B sales and purchase marketing portal.
              </p>
              <div className="flex-align gap-16 mb-16">
                <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                  <i className="ph-fill ph-map-pin"></i>
                </span>
                <div className="flex-align gap-16 flex-wrap">
                  <p className="text-md text-gray-900 hover-text-main-600">
                    <b>Head Office:</b> B 29, 2nd Floor, Pushpanjali Enclave,
                    Pitampura New Delhi
                  </p>
                </div>
              </div>
              <div className="flex-align gap-16 mb-16">
                <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                  <i className="ph-fill ph-phone-call"></i>
                </span>
                <div className="flex-align gap-16 flex-wrap">
                  <a
                    href="tel:8800001259"
                    className="text-md text-gray-900 hover-text-main-600">
                    +91-8800001259
                  </a>
                </div>
              </div>
              <div className="flex-align gap-16 mb-16">
                <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                  <i className="ph-fill ph-phone-call"></i>
                </span>
                <div className="flex-align gap-16 flex-wrap">
                  <a
                    href="tel:9990060509"
                    className="text-md text-gray-900 hover-text-main-600">
                    +91-9990060509
                  </a>
                </div>
              </div>
              <div className="flex-align gap-16 mb-16">
                <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                  <i className="ph-fill ph-envelope"></i>
                </span>
                <a
                  href="mailto:help@indianmsme.org"
                  className="text-md text-gray-900 hover-text-main-600">
                  help@indianmsme.org
                </a>
              </div>
            </div>

            <div className="footer-item">
              <h6 className="footer-item__title">Information</h6>
              <ul className="footer-menu">
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Become a Vendor
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Affiliate Program
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Privacy Policy
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Our Suppliers
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Extended Plan
                  </Link>
                </li>
                <li className="">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Community
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-item">
              <h6 className="footer-item__title">Customer Support</h6>
              <ul className="footer-menu">
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Help Center
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Contact Us
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Report Abuse
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Submit and Dispute
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Policies & Rules
                  </Link>
                </li>
                <li className="">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Online Shopping
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-item">
              <h6 className="footer-item__title">My Account</h6>
              <ul className="footer-menu">
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    My Account
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Order History
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Shoping Cart
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Compare
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Help Ticket
                  </Link>
                </li>
                <li className="">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Wishlist
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-item">
              <h6 className="footer-item__title">Daily Groceries</h6>
              <ul className="footer-menu">
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Dairy & Eggs
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Meat & Seafood
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Breakfast Food
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Household Supplies
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Bread & Bakery
                  </Link>
                </li>
                <li className="">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Pantry Staples
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <div className="bottom-footer bg-color-one py-8">
        <div className="container container-lg">
          <div className="bottom-footer__inner flex-between flex-wrap gap-16 py-16 justify-content-center">
            <p className="bottom-footer__text fadeInLeftBig">
              © 2025 Indian MSME. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
